<template>
  <div>
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.8.2/css/all.css"
      integrity="sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay"
      crossorigin="anonymous"
    >
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.8.2/css/all.css"
      integrity="sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay"
      crossorigin="anonymous"
    >
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.8.2/css/all.css"
      integrity="sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay"
      crossorigin="anonymous"
    >
    <link
      rel="stylesheet"
      href="https://use.fontawesome.com/releases/v5.8.2/css/all.css"
      integrity="sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay"
      crossorigin="anonymous"
    >

    <h2>Links</h2>
    <b-list-group style="margin-bottom: 40px;">
      <b-list-group-item
        class="d-flex align-items-left"
        href="Lin_Dian_Resume.pdf"
        target="_blank"
      >
      <div>
        <i class="fas fa-print fa-1x"></i>
        <span>print me</span>
      </div>
      </b-list-group-item>

      <b-list-group-item
        class="d-flex align-items-left"
        href="mailto:dianlin0708@gmail.com"
        target="_blank"
      >
      <div>
        <i class="far fa-envelope" style=""></i>
        <span>dianlin0708@gmail.com</span>
      </div>
      </b-list-group-item>

      <b-list-group-item
        class="d-flex align-items-left"
        href="https://github.com/dil048"
        target="_blank"
      >
      <div>
        <i class="fab fa-github"></i>
        <span>dil048</span>
      </div>
      </b-list-group-item>

      <b-list-group-item
        class="d-flex align-items-left"
        href="https://www.linkedin.com/in/dianlin1/"
        target="_blank"
      >
      <div>
        <i class="fab fa-linkedin"></i>
        <span >dianlin1</span>
      </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  }
};
</script>

<style scoped>
div{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
h2 {
  font-size: 2em;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: left;
  font-family: "Catamaran", sans-serif;
}
span {
  text-align: left;
  font-weight: 500 !important;
  padding: 0px 5px 0px 5px;
}
#work {
}

@media all and (max-width: 1200px) and (min-width: 577px) {
  span {
    font-size: 0.65em;
  }
  #work {
    font-size: 0.65em !important;
  }
}
</style>
